import type { MenuProduct } from '../shared/domain';
import { useI18n } from './i18n';

// Describe only options present in the public menu projection.
export function recipeFeatures(products: MenuProduct[], channel: string): string[] {
  const features: string[] = [];
  if (products.some(p => p.options.beans.length > 1)) features.push('beans');
  if (products.some(p => p.filterSelection && p.options.beans.some(b => b.origin || b.tastingNotes))) features.push('coffeeDetails');
  if (products.some(p => p.temperature !== 'hot' && p.options.ice.length > 1)) features.push('ice');
  if (products.some(p => p.options.sweetness.length > 1)) features.push('sweetness');
  if (products.some(p => p.options.extras.length)) features.push('extras');
  if (products.length && channel === 'employee') features.push('ownCup');
  return features;
}

export function MenuFeatures({ products, canReadRecipes, channel }: { products: MenuProduct[]; canReadRecipes: boolean; channel: string }) {
  const { t } = useI18n();
  if (!products.length) return null;
  const features = ['discovery'];
  if (products.some(p => p.temperature === 'hot') && products.some(p => p.temperature === 'iced')) features.push('temperature');
  features.push(...recipeFeatures(products, channel), 'quantity', 'savedCart', 'favorites', 'reorder');
  if (products.some(p => p.price !== null && !p.browseOnly)) {
    features.push('prices');
    if (channel === 'employee') features.push('costs');
  }
  if (canReadRecipes) features.push('recipes');
  return <details className="menu-features" aria-label={t('menu.features.title')}>
    <summary>{t('menu.features.title')}</summary>
    <p>{t('menu.features.help')}</p>
    <ul>{features.map(feature => <li key={feature}>{t(`menu.features.${feature}`)}</li>)}</ul>
  </details>;
}

export function RecipeFeatures({ products, channel }: { products: MenuProduct[]; channel: string }) {
  const { t } = useI18n();
  return <ul className="recipe-features" aria-label={t('menu.features.options')}>
    {recipeFeatures(products, channel).map(feature => <li key={feature}>{t(`menu.features.${feature}`)}</li>)}
  </ul>;
}
